import React from "react";
import UseV12Document from "./documents/UseV12Document";
import { TERMS_V12_NOTICE_START_AT, TERMS_V12_EFFECTIVE_AT } from "./clauseVersionDates";

const BiztingTermsOfServiceV12Page = () => {
    const now = new Date();
    const isTermsV12Effective = now >= TERMS_V12_EFFECTIVE_AT;
    const isTermsV12NoticeStarted = now >= TERMS_V12_NOTICE_START_AT;

    return (
        <UseV12Document
            mode={isTermsV12Effective ? "current" : "scheduled"}
            modal={!isTermsV12NoticeStarted || isTermsV12Effective ? undefined : {
                title: "이전 버전 대비 변경사항 요약",
                subtitle: "공고일자: 2026.9.28 · 시행일자: 2026.10.28",
                ctaLabel: "확인",
                content: (
                    <div className="tw-mb-2">
                        <div className="tw-mb-3 tw-flex tw-items-center tw-gap-2 tw-text-[13.5px] tw-font-bold tw-text-[#081f4a]">
                            <span className="tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded tw-bg-[#1a6ef5] tw-text-[11px] tw-font-bold tw-text-white">1</span>
                            주요 변경 조항
                        </div>
                        <div className="tw-overflow-hidden tw-rounded-lg tw-border tw-border-slate-200">
                            <table className="tw-w-full tw-border-collapse tw-text-left tw-text-[13px]">
                                <thead>
                                <tr className="tw-bg-[#081f4a] tw-text-white">
                                    <th className="tw-w-[30%] tw-px-3 tw-py-2.5 tw-font-semibold">조항</th>
                                    <th className="tw-px-3 tw-py-2.5 tw-font-semibold">내용</th>
                                </tr>
                                </thead>
                                <tbody>
                                {[
                                    ["제6조의2 신설", "정식 출시 전 테스트용 베타 서비스 제공 근거 마련"],
                                    ["제20조 개정", "통지 수단에 카카오 알림톡 등 추가 / 약관·정책 변경, 신규 서비스 안내 등 공지 범위 명확화"],
                                    ["제34조(1) 개정", "이용고객과의 통신 수단에 카카오 메시지 추가"],
                                ].map(([label, text], index) => (
                                    <tr key={label} className={`tw-border-t tw-border-slate-200 ${index % 2 === 1 ? "tw-bg-slate-50" : ""}`}>
                                        <td className="tw-px-3 tw-py-2.5 tw-align-top tw-font-semibold">{label}</td>
                                        <td className="tw-px-3 tw-py-2.5">{text}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        <p style={{ fontSize: "12.5px", color: "#8888a8", marginTop: "10px" }}>
                            {"* 본 안내 일부터 1개월 이내에 이의제의가 없을 경우, 개정 내용에 동의하신 것으로 판단됩니다."}
                        </p>
                    </div>
                ),
            }}
        />
    );
};

export default BiztingTermsOfServiceV12Page;
